import { HomebaseEvents } from '~/analytics/homebase/homebaseEvents.types'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

class HomebaseAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.HOMEBASE)
  }

  public logLatestActivity(title: string): void {
    this.logEvent({
      event: HomebaseEvents.LATEST_ACTIVITY,
      title,
    })
  }

  public logLatestActivityTab(): void {
    this.logEvent({
      event: HomebaseEvents.LATEST_ACTIVITY_TAB,
    })
  }

  public logLearningPathTab(): void {
    this.logEvent({
      event: HomebaseEvents.LEARNING_PATH_TAB,
    })
  }
}

export default new HomebaseAnalytics()
